import Sidebar from "@/components/Sidebar/SidebarView.vue";
import Navbar from "@/components/HomeNavBar/HomeNavBar.vue";
import InactivityModal from "@/components/InactivityTracker/InactivityTracker.vue";
import manage_incident_helper from "./manage_incident_helper";
import manage_incident_table_helper from "./manage_incident_table_helper";

export default {
  components: {
    Sidebar,
    Navbar,
    InactivityModal,
  },
  inject: ["client_features"],
  data() {
    return ({
      incident_filters: {
        search: "",
        status: "",
        assignee: "",
      },
      incident_filter_panel_open: false,
      incident_filter_panel_position: {},
      admins: [],
      logged_entries: [],
      incident_pagination: {},
      incident_dashboard: {},
      incident_statuses: [],
      loading: true,
      loading_admins: true,
      incident_error: "",
      updating_incident_status: false,
      incident_progress_note: "",
      notification_incident_opened: false,
      notification_incident_loading: false,
      selected_incident: null,
      selected_incident_assignee: "Unassigned",
      selected_incident_image: null,
      selected_incident_images: [],
      selected_incident_image_index: 0,
    });
  },
  computed: {
    show_sidebar() {
      return this.$route?.name !== "organisation_manage_incidents";
    },
    incident_filter_assignees() {
      return [
        { name: "Unassigned", initials: "UN" },
        ...this.admins.map((admin) => ({
          name: this.get_admin_display_name(admin),
          initials: this.get_admin_initials(admin),
        })),
      ];
    },
    incident_filter_statuses() {
      return this.incident_statuses.map((status, index) => ({
        label: this.normalize_incident_status(status.name),
        value: String(status.name || "").trim().toLowerCase(),
        class_name: this.get_incident_filter_status_class(index),
      }));
    },
    incident_stages() {
      const stage_order = ["reported", "pending", "assigned", "in_progress", "resolved"];
      return stage_order.map((stage_name) => {
        const status = this.incident_statuses.find((item) => item.name === stage_name);
        return {
          id: status?.id || stage_name,
          label: stage_name === "pending"
            ? "Under Review"
            : this.normalize_incident_status(stage_name),
          value: stage_name,
        };
      });
    },
    resolved_incident_status() {
      return this.incident_statuses.find((status) => status.name === "resolved") || null;
    },
    active_incident_filter_count() {
      return Object.values(this.incident_filters).filter(Boolean).length;
    },
    unassigned_incidents() {
      return this.logged_entries.filter((report) => !report.assigned_users?.length).length;
    },
    in_progress_incidents() {
      return this.logged_entries.filter((report) => (
        this.normalize_incident_status(report.incident_status?.name) === "In Progress"
      )).length;
    },
    resolved_incidents() {
      return this.logged_entries.filter((report) => (
        this.normalize_incident_status(report.incident_status?.name) === "Resolved"
      )).length;
    },
    incident_resolution_rate() {
      if (!this.logged_entries.length) return 0;
      return Math.round((this.resolved_incidents / this.logged_entries.length) * 100);
    },
    recent_incident_activity() {
      return [...this.logged_entries]
        .sort((first, second) => (
          this.get_incident_activity_timestamp(second.date_created)
          - this.get_incident_activity_timestamp(first.date_created)
        ))
        .slice(0, 3)
        .map((report) => this.build_recent_incident_activity(report));
    },
  },
  mounted() {
    window.addEventListener("resize", this.position_incident_filter_panel);
    this.get_incident_statuses();
    this.get_organization_admins();
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.position_incident_filter_panel);
    this.close_incident_details();
    this.destroy_incidents_datatable();
  },
  methods: {
    ...manage_incident_helper,
    ...manage_incident_table_helper,
    toggle_sidebar() {
      if (!this.show_sidebar || !this.$refs.sidebar) return;
      this.$refs.sidebar?.$el.classList.toggle("close");
    },
    toggleSidebar() { return this.toggle_sidebar(); },
  },
};
